import { DateTime } from 'luxon';
import { IntegrationStage } from '../../enums/integration-stage';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { FlowType } from '../../types/flow-types';
import { XYPosition } from '../../types/xy-position';
import { FlowNoteConfig } from '../flow-notes/flow-note-config';
import { Guid } from '../guid';
import { FlowParameter } from './flow-parameter';
import { TaskMapping } from './task-mapping';

export class FlowConfig implements IConfigObjectBase {
	id = Guid();
	name = '';
	version = '1.0.0';
	referenceId = Guid();
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	default = true;
	enabled = true;
	microTaskIDs: string[] = [];
	taskMappings: TaskMapping[] = [];
	objectState?: ObjectState;
	firstEdit = true;
	type?: FlowType;
	stage: IntegrationStage = IntegrationStage.Develop;
	flowParameters?: FlowParameter[];
	createdBy?: string;
	autoFlowLayout = true;
	nodePositions: { [key: string]: XYPosition } = {};
	originalFlowId?: string;

	flowEndings: TaskMapping[] = [];
	defaultEndingTaskID?: string;
	notes: FlowNoteConfig[] = [];

	constructor(init?: Partial<FlowConfig>) {
		if (init) {
			Object.assign(this, init);
		}
		this.type = init?.type ?? 'Flow';
		if (!this.nodePositions) this.nodePositions = {};
		if (!this.notes) this.notes = [];
	}
}
